export enum VerificationStatus {
    PENDING = 1,
    APPROVED = 2,
    DECLINED = 3,
    FORGIVEN = 4,
    REOPEN = 5,
    SUBMIT = 6
}